module.exports = __webpack_public_path__ + "static/media/ether-delta.45c2bee4.svg";